import React from 'react';

function SelectGroup({ groups, selectedGroup, onChange }) {
  return (
    <select className="study-select" value={selectedGroup} onChange={onChange}>
      <option value="">— Choose —</option>
      {groups.map((group) => (
        <option key={group.id} value={group.id}>
          {group.name}
        </option>
      ))}
    </select>
  );
}

export default SelectGroup;
